import { render, staticRenderFns } from "./MonthlyLearningStat.vue?vue&type=template&id=bcd1f8aa"
import script from "./MonthlyLearningStat.vue?vue&type=script&lang=js"
export * from "./MonthlyLearningStat.vue?vue&type=script&lang=js"
import style0 from "./MonthlyLearningStat.vue?vue&type=style&index=0&id=bcd1f8aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports